import Vue from 'vue'
import Apis from '@/Apis/_'
import { Paciente, FactoryResponse as ResponseApi } from '@/types/_'
import { UseResolverPacienteDuplicadoState } from './types'

const useResolverPacienteDuplicado = (() => {
  const state = Vue.observable<UseResolverPacienteDuplicadoState>({
    visible: false,
    pacientesDuplicados: [],
    hospitalId: '',
    solicitacaoId: '',
    pacienteHisOriginal: null,
  })

  function abrir({ pacientesDuplicados, hospitalId, solicitacaoId, pacienteHisOriginal }: {
    pacientesDuplicados: Paciente[]
    hospitalId: string
    solicitacaoId: string
    pacienteHisOriginal: Paciente
  }) {
    state.pacientesDuplicados = pacientesDuplicados
    state.hospitalId = hospitalId
    state.solicitacaoId = solicitacaoId
    state.pacienteHisOriginal = pacienteHisOriginal
    state.visible = true
  }

  function fechar() {
    state.visible = false
    state.pacientesDuplicados = []
    state.hospitalId = ''
    state.solicitacaoId = ''
    state.pacienteHisOriginal = null
  }

  async function resolver({ idPacienteMantido, idsPacienteDuplicado }: {
    idPacienteMantido: string
    idsPacienteDuplicado: string[]
  }): Promise<ResponseApi<void>> {
    const his = state.pacienteHisOriginal

    return Apis.Agendamento.AgendamentoMedicoBackofficeApi.resolvePacienteDuplicado({
      hospitalId: state.hospitalId,
      solicitacaoId: state.solicitacaoId,
      idPacienteMantido,
      idsPacienteDuplicado,
      dadosDoPacienteHis: his
        ? {
          hisId: his.hisId,
          nome: his.nome,
          nomeSocial: his.nomeSocial,
          cpf: his.cpf,
          rgh: his.rgh,
          dataNascimento: his.dataNascimento,
          nomeMae: his.nomeMae,
          sexo: his.sexo,
          email: his.email,
          ddiCelular: his.ddiCelular,
          telefone: his.telefone,
          celular: his.celular,
        }
        : undefined,
    })
  }

  return {
    get visible() { return state.visible },
    get pacientesDuplicados() { return state.pacientesDuplicados },
    get hospitalId() { return state.hospitalId },
    get solicitacaoId() { return state.solicitacaoId },
    get pacienteHisOriginal() { return state.pacienteHisOriginal },
    abrir,
    fechar,
    resolver,
  }
})()

export default useResolverPacienteDuplicado
